var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuitcaseIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2306_3972)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2306_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0051 4.52161C18.004 4.52161 18.003 4.52148 18.002 4.52148H13.4863V4.02344C13.4863 3.19958 12.816 2.5293 11.9922 2.5293H8.00781C7.18396 2.5293 6.51367 3.19958 6.51367 4.02344V4.52148H1.99805C1.72075 4.52148 1.5 4.74872 1.5 5.01953V15.9766C1.5 16.8004 2.17029 17.4707 2.99414 17.4707H17.0059C17.8297 17.4707 18.5 16.8004 18.5 15.9766V5.03004C18.5 5.02939 18.5 5.02874 18.5 5.02809C18.4809 4.70099 18.2798 4.52343 18.0051 4.52161ZM7.50977 4.02344C7.50977 3.74886 7.73324 3.52539 8.00781 3.52539H11.9922C12.2668 3.52539 12.4902 3.74886 12.4902 4.02344V4.52148H7.50977V4.02344ZM17.3109 5.51758L15.7642 10.1575C15.6964 10.3612 15.5065 10.498 15.2919 10.498H12.4902V10C12.4902 9.72491 12.2673 9.50195 11.9922 9.50195H8.00781C7.73272 9.50195 7.50977 9.72491 7.50977 10V10.498H4.70812C4.49347 10.498 4.30359 10.3612 4.23576 10.1575L2.68909 5.51758H17.3109ZM11.4941 10.498V11.4941H8.50586V10.498H11.4941ZM17.5039 15.9766C17.5039 16.2511 17.2804 16.4746 17.0059 16.4746H2.99414C2.71957 16.4746 2.49609 16.2511 2.49609 15.9766V8.08862L3.29076 10.4725C3.49439 11.0836 4.06403 11.4941 4.70812 11.4941H7.50977V11.9922C7.50977 12.2673 7.73272 12.4902 8.00781 12.4902H11.9922C12.2673 12.4902 12.4902 12.2673 12.4902 11.9922V11.4941H15.2919C15.936 11.4941 16.5056 11.0836 16.7092 10.4725L17.5039 8.08862V15.9766Z",
    fill: "#2667B0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2306_3972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2306_3972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(1.5 1.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcaseIconBlue);
export default __webpack_public_path__ + "static/media/suitcase_icon_blue.51cf11ee30ea0f66786caf9bbf9e2a80.svg";
export { ForwardRef as ReactComponent };